export default __webpack_public_path__ + "static/media/ag-title-cn.5e5272e8.webp";